import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './demo-data-options.hbs'
import i18n from 'scoreboard/components/i18n'
import DateInput from 'scoreboard/components/date-input'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'

/**
 * Second step of the wizard allowing the user to generate demo data
 * (selecting whether to overwrite existing data and/or extend to a certain date)
 */
var DemoDataOptions = Backbone.View.extend({

	className: 'demo-data-options',

	tagName: 'form',

	initialize: function(options) {
		this.options = options || {}
		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission: true,
			submit: this.submit.bind(this)
		})
	},

	render: function () {
		var title = i18n.get('admin.generateDummyData')
		this.$el.empty().append(template({ title: title }))
		this.dateInput = new DateInput({ el: this.$('[name=extendToDate]'), required: false }).render()
		this.options.wizard.render({
			formView: this.formView,
			doneKey: 'admin.generateDummyData.generate',
			stateSaver: this.saveState.bind(this)
		})
		this.formView.start()
		return this
	},

	saveState: function() {
		_.extend(this.options.demoData, formHelper.readFromDom(this.el))
	},

	submit: function() {
		this.saveState()
		var demoData = this.options.demoData

		$.post({
			url: 'api/admin/demo-data',
			data: JSON.stringify(demoData)
		}).done(function () {
			this.trigger('done')
		}.bind(this))
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.dateInput], 'remove')
	}

})

export default DemoDataOptions

DemoDataOptions.__filename__ = 'admin/demo-data/demo-data-options.js'
